import { useEffect } from "react";
import { useClosableStore } from "..";
import { ClosableOrder } from "../store/ClosableStore";

export default function useClosable(order: ClosableOrder, onClose: () => void) {
    const closableStore = useClosableStore();

    useEffect(() => {
        const id = closableStore.add(order, onClose);
        return () => closableStore.delete(id);
    }, [order, onClose]);
}

export function useConditionallyClosable(order: ClosableOrder, onClose: () => void, isOpen: boolean) {
    const closableStore = useClosableStore();

    useEffect(() => {
        if (isOpen) {
            const id = closableStore.add(order, onClose);
            return () => closableStore.delete(id);
        }
    }, [order, onClose, isOpen]);
}